import { get, put, Delete } from '@/plugins/axios.js'

export const getCountry = (currency, setting) => get(`community/country`, setting)
